import { useEffect } from "react"
import { registerWidgetPlugins, clearWidgetPlugins } from "./plugin"

/**
 * Default plugin registration at application level
 * This is important that it has to be done at the top application level.
 *
 * Don't forget that Highchart plugin system is used by Asset Management pages (like Auris template).
 * It is also used with a default plugin implementation by Wealth pages.
 *
 * This is used for public widget rendering of chart, in case the plugins must be different from the private ones.
 *
 * @returns {null}
 * @constructor
 */
export default function RegisterHighchartsWidgetPlugin() {
  useEffect(() => {
    registerWidgetPlugins()

    return () => {
      clearWidgetPlugins()
    }
  }, [])

  return null
}
